export const publicBook = {
  signUpEmail: '/sign-up-email',
  signUpPassword: '/sign-up-password',
  signIn: '/sign-in',
  resetPassword: '/reset-password',
  welcome: '/welcome',
  signInCode: '/sign-in-code',
  // INJECT
};
